import { OrderCompact, OrderSummary } from '@lib/types';

export function fromOrderCompactToOrderSummary(
  order: OrderCompact,
): OrderSummary {
  return {
    uuid: order.uuid,
    state: order.state,
    shortCode: order.shortCode,
    createdAt: new Date(order.createdAt),
    refSummary: null,
    userSummary: {
      name: order.name,
      address: order.address,
      phone: order.phone,
    },
    assignedLiveTrackerAgent: null,
    isFleet: order.isFleet,
  };
}
